import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=ce324a7e&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=js&"
export * from "./main-footer.vue?vue&type=script&lang=js&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=ce324a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce324a7e",
  null
  
)

export default component.exports